import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useEffect, useState } from 'react'
import chatApi from 'services/api/chat'

import styles from './ChatbotHelpMessages.module.scss'

const chatbotHelpMessagesDescriptions = {
  A: 'Make a new booking',
  B: 'Learn the date of your last checkout',
  C: 'Learn the check-in time',
  D: 'Learn the check-out time',
  E: 'Hotel hotel address'
}

const ChatbotHelpMessages = ({ onClose }) => {
  const [isLoading, setIsLoading] = useState()
  const [isErred, setIsErred] = useState()
  const [helpMessages, setHelpMessages] = useState()

  const [helpTitle, setHelpTitle] = useState('')
  const [helpTitleAlternative, setHelpTitleAlternative] = useState('')

  function handleSave() {
    setIsLoading(true)

    chatApi
      .updateHelpContent({
        title: helpTitle,
        titleUndefinedMessage: helpTitleAlternative,
        contents: helpMessages.map(m => ({
          contentId: m.chatHelpContentId,
          text: m.text
        }))
      })
      .then(() => {
        setIsLoading(false)
        onClose()
      })
      .catch(() => {
        setIsErred(true)
      })
  }

  useEffect(() => {
    setIsLoading(true)

    chatApi
      .getHelpContent()
      .then(data => {
        setHelpMessages(data.contents)
        setHelpTitle(data.title)
        setHelpTitleAlternative(data.titleUndefinedMessage)
        setIsErred(false)
      })
      .catch(() => {
        setIsErred(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  return (
    <ConfirmationDialog
      onClose={onClose}
      title="Customize chatbot help menu messages"
      positiveMessage="Save changes"
      negativeMessage="Cancel"
      onConfirm={handleSave}
      maxWidth={700}
    >
      {isLoading && <LoadingIndicator inline />}
      {isErred && <p>Something went wrong</p>}
      {!isLoading && !isErred && (
        <div>
          <div className={styles.inputHolder}>
            <TextInput
              label={'Help title'}
              value={helpTitle}
              onChange={e => setHelpTitle(e.target.value)}
            />
          </div>
          <div className={styles.inputHolder}>
            <TextInput
              label={'Help title for unidentified message'}
              value={helpTitleAlternative}
              onChange={e => setHelpTitleAlternative(e.target.value)}
            />
          </div>
          {helpMessages
            ?.sort((a, b) => a.key.localeCompare(b.key))
            .map(message => (
              <div key={message.chatHelpContentId}>
                <div className={styles.inputHolder}>
                  <TextInput
                    label={`${message.key}. ${
                      chatbotHelpMessagesDescriptions[message.key]
                    }`}
                    value={message.text}
                    onChange={e =>
                      setHelpMessages([
                        ...helpMessages.filter(
                          m => m.chatHelpContentId !== message.chatHelpContentId
                        ),
                        { ...message, text: e.target.value }
                      ])
                    }
                  />
                </div>
              </div>
            ))}
        </div>
      )}
    </ConfirmationDialog>
  )
}

export default ChatbotHelpMessages
